<template>
  <nav id="header-nav-main">
    <ul class="nav nav-pills" id="mainNav">
      <li v-for="node in getNav"
          class="dropdown dropdown-mega"
          :class="{
            hover: isHover(node.id) && node.menus.length,
            'clearance-li': node.name.toLowerCase() === 'clearance',
          }"
          :key="node.id"
          @mouseenter="enterHover(node.id)"
          @mouseleave="leaveHover(node.id)">
        <a
          :class="{
            'dropdown-toggle': node.menus.length,
            'empty-menu': node.menus.length == 0,
            'clearance-a': node.name.toLowerCase() === 'clearance',
          }"
          :href="$catLink(node.seo_link)">{{ node.name }}</a>
        <ul v-if="node.menus.length" class="dropdown-menu">
          <li>
            <div class="dropdown-mega-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <template v-for="row in getRows(node.menus)">
                      <div v-for="subnode in getRow(row,node.menus)"
                           class="col-md-3"
                           :key="subnode.id">
                        <a :href="$catLink(subnode.seo_link)"
                           class="dropdown-mega-sub-title">{{ subnode.name
                          }}</a>

                        <ul v-if="subnode.menus.length > 0"
                            class="dropdown-mega-sub-nav">
                          <li v-for="submenu in getLimited(subnode.menus)"
                              :key="submenu.id">
                            <a
                                :href="$catLink(submenu.seo_link)">{{
                              submenu.name }}</a>
                          </li>
                          <li v-if="subnode.menus.length > 5">
                            <a :href="$catLink(subnode.seo_link)"><strong>View
                              all {{subnode.name }}...</strong></a>
                          </li>
                        </ul>
                      </div>
                      <div class="clearfix"></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </li>
      <li v-if="slotHasContent"
          class="dropdown dropdown-extra header-li"
          :class="{hover:isHover(0)}"
          @mouseenter="enterHover(0)"
          @mouseleave="leaveHover(0)">
        <a class="dropdown-toggle" href="#">Heat</a>
        <ul class="dropdown-menu">
          <slot></slot>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
  import HeaderNavMain from "^/top-level/header-nav-main"
  export default {
    name: 'header-nav-main',
    extends: HeaderNavMain,
    computed: {
      slotHasContent() {
        return !!(this.$slots.default || [])[0]
      }
    }
  }
</script>

<style scoped>
  .sticky-header-active #header .header-nav-main nav {
    background-color: #f0f0ed;
  }
  .dropdown-extra .dropdown-menu {
    padding: 0 !important;
  }
  .dropdown-extra .dropdown-menu li {
    float: none;
  }
  .dropdown-extra .dropdown-menu li:not(:first-child) {
    border-top: none !important;
  }
  .clearance-a {
    color: #BB141A !important;
  }
  body header#header div.header-nav-main nav ul li.clearance-li:hover a {
    color: white !important;
    background-color: #BB141A !important;
  }
</style>



// WEBPACK FOOTER //
// ixcms/themes/jedco/src/vue-src/top-level/header-nav-main.vue